// components/common/Fieldset.js
import React from "react";

const Fieldset = ({ legend, children, className = "" }) => {
  return (
    <fieldset className={`border rounded-3 p-3 bg-white w-100 ${className}`}>
      <legend className="float-none w-auto px-2 fw-bold primary-text small">
        {legend}
      </legend>
      {children}
    </fieldset>
  );
};

export default Fieldset;
